// HeroSection.js - Estatica Skin and Laser

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/treatments/HeroSection.css";

const filters = ["All", "Facial", "Acne", "Skin Rejuvenation", "Laser"];

const HeroSection = ({ activeFilter, setActiveFilter }) => {
  return (
    <section className="estatica-treat">
      <Container>
        <Row>
          <Col xs={12}>
            <p className="estatica-treat__label">Our Treatments</p>

            <h2 className="estatica-treat__heading">
              Skin &amp; laser care, tailored to you.
            </h2>

            <p className="estatica-treat__subtext">
              Dermatologist-led protocols across facials, acne, rejuvenation and
              laser categories.
            </p>

            <div className="estatica-treat__filters">
              {filters.map((filter) => (
                <button
                  key={filter}
                  className={`estatica-treat__filter-btn ${
                    activeFilter === filter
                      ? "estatica-treat__filter-btn--active"
                      : ""
                  }`}
                  onClick={() => setActiveFilter(filter)}
                >
                  {filter}
                </button>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;